<template>
  <div class="platform_introduction">
    <div class="introduction_image">
      <img class="full_img" :src="introductionImage" alt="" />
    </div>
    <div class="introduction_title">{{ title }}</div>
    <p class="introduction_line"></p>
    <div class="introduction_explain">{{ content }}</div>
  </div>
</template>
<script>
export default {
  name: 'PlatformIntroduction',
  data() {
    return {}
  },
  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    introductionImage: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="less" scoped>
.platform_introduction {
  display: flex;
  flex-direction: column;
  align-items: center;
  .introduction_image {
    width: 100px;
    height: 100px;
  }
  .introduction_title {
    margin-top: 10px;
    height: 50px;
    line-height: 50px;
    font-size: 36px;
    font-family: PingFangSC-Semibold, 'PingFang SC';
    font-weight: 600;
    color: #ffffff;
  }
  .introduction_line {
    margin: 10px 0 5px;
    width: 40px;
    height: 2px;
    background: #c29393;
  }
  .introduction_explain {
    width: 300px;
    line-height: 28px;
    font-size: 20px;
    font-family: PingFangSC-Regular, 'PingFang SC';
    font-weight: 400;
    color: #e9e5e5;
  }
}
</style>
